import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function DangerCircle({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <DangerCircle.Outline {...props} />
  ) : (
    <DangerCircle.Solid {...props} />
  );
}

DangerCircle.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M11.9951 7.4541C12.4093 7.4541 12.7451 7.78989 12.7451 8.2041V12.6231C12.7451 13.0373 12.4093 13.3731 11.9951 13.3731C11.5809 13.3731 11.2451 13.0373 11.2451 12.6231V8.2041C11.2451 7.78989 11.5809 7.4541 11.9951 7.4541Z"
          fill="currentColor"
        />
        <path
          d="M11.9951 14.7961C11.4428 14.7961 10.9951 15.2439 10.9951 15.7961C10.9951 16.3484 11.4428 16.7961 11.9951 16.7961H12.0051C12.5574 16.7961 13.0051 16.3484 13.0051 15.7961C13.0051 15.2439 12.5574 14.7961 12.0051 14.7961H11.9951Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 12C2 6.47679 6.47679 2 12 2C17.5222 2 22 6.47673 22 12C22 17.5222 17.5222 22 12 22C6.47673 22 2 17.5222 2 12ZM12 3.5C7.30521 3.5 3.5 7.30521 3.5 12C3.5 16.6938 7.30527 20.5 12 20.5C16.6938 20.5 20.5 16.6938 20.5 12C20.5 7.30527 16.6938 3.5 12 3.5Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

DangerCircle.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M22.795 12.6582C22.795 18.1822 18.318 22.6582 12.795 22.6582C7.27204 22.6582 2.79504 18.1822 2.79504 12.6582C2.79504 7.1362 7.27204 2.6582 12.795 2.6582C18.318 2.6582 22.795 7.1362 22.795 12.6582Z"
          className="icon-secondary"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.6652 13.2891C13.6652 13.7711 13.2722 14.1641 12.7902 14.1641C12.3082 14.1641 11.9152 13.7711 11.9152 13.2891V8.86914C11.9152 8.38714 12.3082 7.99414 12.7902 7.99414C13.2722 7.99414 13.6652 8.38714 13.6652 8.86914V13.2891ZM11.9202 16.4619C11.9202 15.9799 12.3112 15.5869 12.7902 15.5869C13.2832 15.5869 13.6752 15.9799 13.6752 16.4619C13.6752 16.9439 13.2832 17.3369 12.8002 17.3369C12.3152 17.3369 11.9202 16.9439 11.9202 16.4619Z"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
